import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { environments } from './environment/services/environment.configuration';
var ɵ0 = adapterFactory, ɵ1 = environments;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1 };
